<template>
  <div>
    <vAlert theme="info">{{$t('fbb.alloment.tip', { defaultValue: '支持仓库调入指定地址，或从指定地址调入仓库，若为指定地址调出或调入，则仓库选择Other，具体地址手动录入' })}}</vAlert>
    <compWrapper :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="primary">
      <compFormQuery
        v-if="type==='query'"
        class="margin-layout"
        :formdata="getBase"
        :value="formData"
      ></compFormQuery>
      <compFormEdit
        v-else
        ref="formbase"
        class="margin-layout"
        :formdata="getBase"
        v-model="formData"
        labelWidth="130"
      ></compFormEdit>
    </compWrapper>
    <compWrapper :title="$t('global.common.attache', { defaultValue: '附件信息' })" theme="info">
      <compAttach class="margin-layout" ref="attachlist" :data="attachList" :status="status" :checkManage="checkManage"></compAttach>
    </compWrapper>
    <compWrapper :title="$t('fbb.alloment.product_detail', { defaultValue: '产品明细' })" theme="success">
      <compProduct
        class="margin-layout"
        ref="productlist"
        :data="productList"
        :warehouseType="formData.warehouseType"
        :baseData="formData"
      ></compProduct>
      <vButtonGroup slot="footer" v-if="isQuery">
         <vButton
          v-if="isManageBill&&(formData.subTransferPlanStatus===10||formData.subTransferPlanStatus===20)"
          theme="info"
          class="margin-right-15"
          @click="repushWms"
        >{{$t('fbb.inbound.repush_warehouse', { defaultValue: '重推仓库' })}}</vButton>
        <vButton
          v-if="isManageBill&&formData.subTransferPlanStatus==5"
          theme="primary"
          class="margin-right-15"
          @click="showModal=true"
        >{{$t('fbb.alloment.button_audit', { defaultValue: '审核' })}}</vButton>
        <vButton
          v-if="isManageBill&&(formData.subTransferPlanStatus==10||formData.subTransferPlanStatus==15||formData.subTransferPlanStatus==20||formData.subTransferPlanStatus==25)"
          @click="submitComplete"
          theme="success"
          class="margin-right-15"
        >{{$t('global.common.finish', { defaultValue: '完成' })}}</vButton>
        <vButton v-if="type!=='query'" theme="primary" class="margin-right-15" @click="submit()">{{$t('fbb.inbound.save_draft', { defaultValue: '保存为草稿' })}}</vButton>
        <vButton v-if="type =='add'" theme="success" class="margin-right-15" @click="submit(true)">{{$t('fbb.inbound.submit_audit', { defaultValue: '提交审核' })}}</vButton>
        <vButton
          v-if="formData.transferOutboundPlanStatus==0||formData.transferOutboundPlanStatus==3"
          theme="success"
          class="margin-right-15"
          @click="submit(true)"
        >{{$t('fbb.inbound.submit_audit', { defaultValue: '提交审核' })}}</vButton>
        <vButton
          v-if="!isManageBill&&type ==='query'&&formData.transferOutboundPlanStatus==5"
          class="margin-right-15"
          theme="info"
          @click="rebackaudit"
        >{{$t('fbb.inbound.cancel_audit', { defaultValue: '撤销审核' })}}</vButton>
        <vButton
          v-if="!isManageBill&&type ==='query' && formData.transferOutboundPlanStatus==8"
          class="margin-right-15"
          theme="primary"
          @click="sure"
        >{{$t('global.datepicker.confirm', { defaultValue: '确认' })}}</vButton>
          <vButton
        v-if="type ==='query' && formData.errorCode!==0"
        class="margin-right-15"
        theme="success"
        @click="reprocess"
      >{{$t('fbb.alloment.reprocess', { defaultValue: '重处理' })}}</vButton>
 <vButton
        v-if="type ==='query' && formData.errorCode!==0"
        class="margin-right-15"
        theme="info"
        @click="backToNormal"
      >{{$t('fbb.alloment.back_to_normal', { defaultValue: '忽略异常' })}}</vButton>
        <vButton class="margin-right-15" @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
      </vButtonGroup>
    </compWrapper>
    <compPhotoLog v-if="type === 'query'" v-bind="photoData"></compPhotoLog>
    <compLog v-if="type==='query'" wrapper :data="logList"></compLog>
    <vButtonGroup class="text-right" v-if="!isQuery">
       <vButton
          v-if="isManageBill&&(formData.subTransferPlanStatus===10||formData.subTransferPlanStatus==20)"
          theme="info"
          class="margin-right-15"
          @click="repushWms"
        >{{$t('fbb.inbound.repush_warehouse', { defaultValue: '重推仓库' })}}</vButton>
      <vButton
        v-if="isManageBill&&formData.subTransferPlanStatus==5"
        theme="primary"
        class="margin-right-15"
        @click="showModal=true"
      >{{$t('fbb.alloment.button_audit', { defaultValue: '审核' })}}</vButton>
      <vButton
        v-if="isManageBill&&(formData.subTransferPlanStatus==10||formData.subTransferPlanStatus==15||formData.subTransferPlanStatus==20||formData.subTransferPlanStatus==25)"
        @click="submitComplete"
        theme="success"
        class="margin-right-15"
      >{{$t('global.common.finish', { defaultValue: '完成' })}}</vButton>
      <vButton
        v-if="!isManageBill&&(formData.transferOutboundPlanStatus==0||formData.transferOutboundPlanStatus==3)"
        theme="success"
        class="margin-right-15"
        @click="submit(true)"
      >{{$t('fbb.inbound.submit_audit', { defaultValue: '提交审核' })}}</vButton>
      <vButton
        v-if="!isManageBill&&type ==='query'&&formData.transferOutboundPlanStatus==5"
        class="margin-right-15"
        theme="info"
        @click="rebackaudit"
      >{{$t('fbb.inbound.cancel_audit', { defaultValue: '撤销审核' })}}</vButton>
      <vButton
        v-if="!isManageBill&&type ==='query' && formData.transferOutboundPlanStatus==8"
        class="margin-right-15"
        theme="success"
        @click="sure"
      >{{$t('global.datepicker.confirm', { defaultValue: '确认' })}}</vButton>
      <vButton
        v-if="!isManageBill&&type ==='query' && (formData.transferOutboundPlanStatus==0||formData.transferOutboundPlanStatus==3||
          formData.transferOutboundPlanStatus==5||formData.transferOutboundPlanStatus==6||formData.transferOutboundPlanStatus==8||
          formData.transferOutboundPlanStatus==10||(formData.transferOutboundPlanStatus==20 && formData.orderType!==0&&formData.orderType!==4)||formData.transferOutboundPlanStatus==120)"
        class="margin-right-15"
        theme="error"
        @click="cancelOrder"
      >{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
       <vButton
        v-if="type ==='query' && formData.errorCode!==0"
        class="margin-right-15"
        theme="success"
        @click="reprocess"
      >{{$t('fbb.alloment.reprocess', { defaultValue: '重处理' })}}</vButton>
 <vButton
        v-if="type ==='query' && formData.errorCode!==0"
        class="margin-right-15"
        theme="info"
        @click="backToNormal"
      >{{$t('fbb.alloment.back_to_normal', { defaultValue: '忽略异常' })}}</vButton>

      <vButton class="margin-right-15" @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
    </vButtonGroup>
    <vLoading size="large" transfer :loading="loading"></vLoading>
    <compModal
      v-model="showModal"
      v-bind="getApporveProps"
      @on-close="showModal=false"
      @on-confirm="cancel"
    ></compModal>
    <compModal v-model="operate.show" v-bind="operate" @on-close="operate.show=false">
      <component
        v-if="operate.component"
        :is="operate.component"
        v-bind="operate.props"
        @on-close="operate.show=false"
        v-on="operate.on"
      />
    </compModal>
  </div>
</template>

<script>
import {
  HttpPlanBill,
  HttpSubmiPlanBill,
  HttpCancelPlanBill,
  HttpSavePlanBill,
  HttpUpdatePlanBill,
  HttpApprovePlanBill,
  HttpWarehouseAddress,
  HttpWareHouseCodeList,
  HttpCompletePlanBill,
  HttpFindByOrgIdAndOrgWarehouseId,
  HttpSubPlanBill,
  HttpSubPlanGet,
  HttpAllSureBill,
  HttpRetryWms,
  HttpSubApprovePlanBill,
  HttpRebackAuditPlanBill,
  HttpCheckWarehouse,
  HttpReprocessPlanBill,
  HttpBackToNormalPlanBill
} from "@/service/allotment";

import { mapGetters } from "vuex";
import compAttach from "./attach";
import compProduct from "./product";
import mixin from "../mixin";

export default {
  mixins: [mixin],
  props: ["activeid"],
  components: {
    compWrapper: () => import("@components/templates/wrapper"),
    compFormQuery: () => import("@components/templates/formquery"),
    compFormEdit: () => import("@components/templates/formedit"),
    compLog: () => import("@components/templates/log"),
    compModal: () => import("@components/templates/modal"),
    compAttach,
    compProduct
  },
  data() {
    return {
      loading: false,
      type: this.$route.params.type,
      id: this.$route.query.id,
      showModal: false,
      showTimebef:true,
      showTimeAft:false,
      showInTimebef:true,
      showInTimeAft:false,
      showRel: false,
      checkWarehouse:false,
      codeList: [],
      logList: [],
      attachList: [],
      status:"",
      checkManage:"",
      boxingList: [],
      productList: [],
      subTransferPlansEntity: {},
      formData: {
        isLabel: 0,
        transportationType: 2,
        inventoryType: 0
      },
      showOnaccount: false,
      showInaccount: false,
      channelList1: [],
      channelList2: [],
      operate: {
        show: false
      },
      photoData: {}
    };
  },
  created() {
    this.checkManage = 0;
    if (this.activeid) {
      /* this.$route.name = "allotUpdateManage"; */
      this.id = this.activeid;
      this.type = "query";
      this.$route.params.type = "query";
      this.$route.query.id = this.activeid;
    }
    this.getDetail();
  },
  computed: {
    ...mapGetters("dictionary", [
      "getFBBFilterDisabledAllWarehouse",
      "getProductList",
      "getOrgList",
      "getCusAccountList",
      "getBillcusWareList",
      "getWarehouseList",
        "getCountryList"
    ]),
    // ...mapGetters("common", ["getCountryList"]),
    isQuery() {
      if (this.activeid) {
        return false;
      } else {
        return true;
      }
    },
    isManageBill() {
      return (
        this.$route.name === "allotUpdateManage" ||
        this.$route.name === "allotManageBill"
      );
    },

    getApporveProps() {
      return {
        alert: "info",
        title: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
        width: "middle",
        showDesc: false,
        params: {
          ids: this.id
        },
        ajaxRequest: HttpSubApprovePlanBill,
        formdata: [
          {
            tag: "vRadio",
            key: "actionType",
            span: 24,
            label: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
            labelWidth: 120,
            default: 500,
            options: [
              {
                label: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                trueValue: 500
              },
              {
                label: this.$t('fbb.inbound.back_audit', { defaultValue: "审核拒回" }),
                trueValue: 600
              }
            ]
          },
          {
            label: this.$t('fbb.alloment.warehouse_out_bound_at', { defaultValue: "预计出库日期" }),
            tag: "vDatepicker",
            key: "warehouseEstimateOutboundAt",
            labelWidth: 120,
            show:this.formData.orderType==1,
            span: 24,
            props: {
              format: "yy-mm-dd"
            },
            required: false
          },
          {
            tag: "vTextarea",
            key: "reason",
            span: 24,
            label: this.$t('global.common.notes', { defaultValue: "备注" }),
            required: false
          }
        ]
      };
    },
    getBase() {
      const isEdit = this.type === "edit",
        isQuery = this.type === "query";
      return [
        {
          label: this.$t('fbb.allotment.bill', { defaultValue: "调拨计划单号" }),
          key: "transferOutboundPlanNo",
          query: true,
          show: this.type !== "add" && !this.isManageBill,
          render: h => {
            const {
              transferOutboundPlanStatus,
              transferOutboundPlanNo,
              errorCode
            } = this.formData;
            const data =
              this.getBillStatus.find(
                item => item.value === transferOutboundPlanStatus
              ) || {};
            return (
              <div>
                {this.formData.transferOutboundPlanNo}
                <vButton
                  ghost
                  theme={data.theme}
                  style="margin-left:5px;padding:1px 10px;cursor:unset;"
                >
                  {data.label}
                </vButton><span style="margin-left:5px;color:red;">{this.findRenderLabel(this.getErrorType, errorCode)} </span>
              </div>
            );
          }
        },
        {
          label: this.$t('fbb.allotment.bill', { defaultValue: "调拨计划单号" }),
          key: "subTransferPlanNo",
          query: true,
          show: this.isManageBill,
          render: h => {
            const { subTransferPlanStatus, subTransferPlanNo,errorCode } = this.formData;
            const data =
              this.getBillStatus.find(
                item => item.value === subTransferPlanStatus
              ) || {};
            return (
              <div>
                {this.formData.subTransferPlanNo}
                <vButton
                  ghost
                  theme={data.theme}
                  style="margin-left:5px;padding:1px 10px;cursor:unset;"
                >
                  {data.label}
                </vButton><span style="margin-left:5px;color:red;">{this.findRenderLabel(this.getErrorType, errorCode)} </span>
              </div>
            );
          }
        },
        {
          label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
          key: "sourceNo",
          query: true,
          show: this.isManageBill,
         /*  render: h => {
            const { transferOutboundPlanNo } = this.formData;
            return <div>{this.formData.transferOutboundPlanNo}</div>;
          } */
        },
        {
          label: this.$t('global.common.line', { defaultValue: "项目" }),
          tag: "vSelect",
          key: "lineId",
          options: this.getProductList,
          show: !(isEdit || isQuery),
          props: {
            filterable: true
          }
        },
        {
          label: this.$t('global.common.line', { defaultValue: "项目" }),
          // tag: "vSelect",
          key: "lineName",
          show: isEdit || isQuery
        },
        {
          label: this.$t('global.common.organization', { defaultValue: "组织" }),
          query: true,
          key: "organizationId",
          options: this.getOrgList,
          show: isQuery && this.isManageBill
        },
        {
            label: this.$t('fbb.alloment.alloment_type', { defaultValue: "调拨类型" }),
          // tag: "vSelect",
          show: this.isManageBill && this.formData.orderType === 1,
          render:h =>{
            return <div>{this.$t('fbb.alloment.alloment_out', { defaultValue: '调拨出库' })}</div>
          }
        },
         {
            label: this.$t('fbb.alloment.alloment_type', { defaultValue: "调拨类型" }),
          // tag: "vSelect",
          show: this.isManageBill && this.formData.orderType === 2,
          render:h =>{
            return <div>{this.$t('fbb.alloment.alloment_in', { defaultValue: '调拨入库' })}</div>
          }
        },
        {
          label: this.$t('fbb.alloment.out_warehouse', { defaultValue: "调出仓库" }),
          // tag: "vSelect",
          key: "orgWarehouseCode",
          show: isQuery && !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.out_warehouse', { defaultValue: "调出仓库" }),
          // tag: "vSelect",
          key: "orgWarehouseCode",
          show: this.isManageBill && this.formData.orderType === 1
        },
        {
          label: this.$t('fbb.alloment.in_warehouse', { defaultValue: "调入仓库" }),
          // tag: "vSelect",
          key: "inOrgWarehouseCode",
          show: isQuery && !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.in_warehouse', { defaultValue: "调入仓库" }),
          // tag: "vSelect",
          key: "inOrgWarehouseCode",
          show: this.isManageBill && this.formData.orderType === 2
        },
        {
          label: this.$t('fbb.alloment.out_warehouse', { defaultValue: "调出仓库" }),
          tag: "vSelect",
          key: "orgWarehouseId",
          options: this.isManageBill
            ? this.getBillcusWareList
            : this.getFBBFilterDisabledAllWarehouse,
          show: !isQuery,
          props: {
            filterable: true
          },
          on: {
            "on-attach": (attach, val) => {
            //   console.log(attach)
              // console.log(attach,'attach',val)
              this.formData.orgWarehouseCode = attach.code;
              this.formData.warehouseType = attach.warehouseType;
              if (attach.warehouseType == 4) {
                // console.log(1212)
                this.showOnaccount = true;
                this.getChannel(val, "outware");
              } else this.showOnaccount = false;
            //   console.log(this.formData)
              if(this.formData.orgWarehouseId===0){
                // console.log(12121)
                this.showTimebef = false;
                this.showTimeAft = true;
              }else{
                if(this.formData.warehouseType===2){
                  this.showTimebef = false;
                  this.showTimeAft = true;
                }else{
                  this.showTimebef = true;
                  this.showTimeAft = false;
                }
              }
            }
          }
        },
        {
          label: this.$t('fbb.alloment.in_warehouse', { defaultValue: "调入仓库" }),
          tag: "vSelect",
          key: "inOrgWarehouseId",
          options: this.isManageBill
            ? this.getBillcusWareList
            : this.getFBBFilterDisabledAllWarehouse,
          show: !isQuery,
          props: {
            filterable: true
          },
          on: {
            "on-attach": (attach, val) => {
              this.getInWarehouseAttach(attach, val);
              this.formData.inWarehouseType = attach.warehouseType;
              if (attach.warehouseType == 4) {
                this.showInaccount = true;
                this.getChannel(val, "inware");
              } else this.showInaccount = false;
            //   console.log(this.formData)
              if(this.formData.inOrgWarehouseId===0){
                // console.log(12121)
                this.showInTimebef = false;
                this.showInTimeAft = true;
              }else{
                if(this.formData.inWarehouseType===2){
                  this.showInTimebef = false;
                  this.showInTimeAft = true;
                }else{
                  this.showInTimebef = true;
                  this.showInTimeAft = false;
                }
              }
            }
          }
        },
        {
          label: this.$t('fbb.alloment.onsite_out', { defaultValue: "ONSITE仓调出渠道" }),
          key: "onsiteChannel",
          show: isQuery && this.showOnaccount && !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.onsite_in', { defaultValue: "ONSITE仓调入渠道" }),
          key: "inOnsiteChannel",
          show: isQuery && this.showInaccount
        },
        {
          label: this.$t('fbb.alloment.onsite_out', { defaultValue: "ONSITE仓调出渠道" }),
          tag: "vSelect",
          key: "onsiteChannel",
          options: this.channelList1.map(item => {
            return {
              label: item.accountFlag,
              value: item.accountFlag
            };
          }),
          show: this.showOnaccount && !isQuery,
          props: {
            filterable: true
          }
        },
        {
          label: this.$t('fbb.alloment.onsite_in', { defaultValue: "ONSITE仓调入渠道" }),
          tag: "vSelect",
          key: "inOnsiteChannel",
          options: this.channelList2.map(item => {
            return {
              label: item.accountFlag,
              value: item.accountFlag
            };
          }),
          show: this.showInaccount && !isQuery,
          props: {
            filterable: true
          }
        },
        {
          label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
          tag: "vRadio",
          custom: true,
          key: "inventoryType",
          options: this.getInventoryType.map(item => {
            return {
              label: item.label,
              trueValue: item.value
            };
          })
        },
        {
          label: this.$t('fbb.alloment.transport_type', { defaultValue: "运输方式" }),
          tag: "vRadio",
          key: "transportationType",
          custom: true,
          required: false,
          options: this.getTransportType.map(item => {
            return {
              label: item.label,
              trueValue: item.value
            };
          })
        },
        {
          label: this.$t('fbb.alloment.is_change_product', { defaultValue: "是否更换产品标" }),
          tag: "vRadio",
          key: "isLabel",
          required: false,
          custom: true,
          options: [
            {
              trueValue: 1,
              label: this.$t('erp.global.yes',{defaultValue:'是'})
            },
            {
              trueValue: 0,
              label: this.$t('erp.global.no',{defaultValue:'否'})
            }
          ]
        },
        {
          label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
          key: "sourceNo",
          required: false,
          show: !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.expect_out_bound_time', { defaultValue: "期望出库日期" }),
          tag: "vDatepicker",
          show:this.showTimeAft,
          key: "estimateOutboundTime",
          required:false
        },
         {
          label: this.$t('fbb.alloment.expect_out_bound_time', { defaultValue: "期望出库日期" }),
          tag: "vDatepicker",
          key: "estimateOutboundTime",
          show:this.showTimebef,
          required:true
        },
          {
          label: this.$t('fbb.alloment.expect_in_bound_time', { defaultValue: "期望入库日期" }),
          tag: "vDatepicker",
          show:this.showInTimeAft,
          props: {
              format: "yy-mm-dd"
            },
          key: "estimateInboundTime",
          required:false
        },
         {
          label: this.$t('fbb.alloment.expect_in_bound_time', { defaultValue: "期望入库日期" }),
          tag: "vDatepicker",
          key: "estimateInboundTime",
          props: {
              format: "yy-mm-dd"
            },
          show:this.showInTimebef,
          required:true
        },
        {
          label: "Shipment ID",
          key: "shipmentId",
          required: false,
          formItem: isQuery
            ? null
            : {
                tip:
                  `<span class=color-error>${this.$t('fbb.alloment.tip_2', { defaultValue: '如发往FBA请填写FBA Shipment id' })}</span>`
              }
        },
        {
          label: this.$t('fbb.alloment.warehouse_out_bound_at', { defaultValue: "预计出库日期" }),
          key: "warehouseEstimateOutboundAt",
          show: isQuery
        },
        {
          label: "Remove Order ID/Reference ID",
          key: "removeOrderId",
          required: false,
          formItem: isQuery
            ? null
            : {
                tip:
                  `<span class=color-error>${this.$t('fbb.alloment.tip_3', { defaultValue: '如从FBA移出请填写FBA Remove ID' })}</span>`
              }
        },
        {
          label: this.$t('fbb.alloment.receive_store', { defaultValue: "目的地地址CODE" }),
          // tag: "vSelect",
          key: "receiveStore",
          options: this.codeList,
          show: !this.isManageBill,
          props: {
            filterable: true
          },
          on: {
            "on-attach": this.getAllotAddressByCode
          }
        },
        {
          label: this.$t('fbb.alloment.ship_to_country', { defaultValue: "目的地国家" }),
          tag: "vSelect",
          key: "shipToCountry",
          show: !this.isManageBill,
          options: this.getCountryList,
          props: {
            filterable: true
          }
        },
        {
          label: this.$t('fbb.alloment.ship_to_state', { defaultValue: "目的地州" }),
          show: !this.isManageBill,
          key: "shipToState"
        },
        {
          label: this.$t('fbb.alloment.ship_to_city', { defaultValue: "目的地城市" }),
          key: "shipToCity",
          show: !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.ship_to_postal', { defaultValue: "目的地邮编" }),
          key: "shipToPostal",
          show: !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.ship_to_address1', { defaultValue: "目的地地址1" }),
          key: "shipToAddress1",
          show: !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.ship_to_address', { defaultValue: "目的地地址" }),
          key: "shipToAddress1",
          show: this.isManageBill,
           render: h => {
              const {
              shipToAddress1,
              shipToAddress2,
              shipToCity,
              shipToState,
              shipToCountry,
              shipToPostal,
              shipToContact,
              shipToTelephone
            } = this.formData;
             return (
               <div>
               <span>{shipToAddress1 || "-"}</span>,
               <span>{shipToAddress2 || "-"}</span>,
                <span>{shipToCity || "-"}</span>,
                <span>{shipToState || "-"}</span>,
                <span>{shipToCountry || "-"}</span>,
                <span>{shipToPostal || "-"}</span>,
                <span>{shipToContact || "-"}</span>,
                <span>{shipToTelephone || "-"}</span>,
               </div>

             )
           }

        },
        {
          label: this.$t('fbb.alloment.ship_to_address2', { defaultValue: "目的地地址2" }),
          key: "shipToAddress2",
          required: false,
          show: !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.ship_to_contact', { defaultValue: "联系人" }),
          key: "shipToContact",
          show: !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.ship_to_telephone', { defaultValue: "电话" }),
          key: "shipToTelephone",
          required: false,
          show: !this.isManageBill
        },
        {
          label: this.$t('fbb.alloment.relTransferPlanNo', { defaultValue: "关联调拨出库计划单" }),
          key: "relTransferPlanNo",
          props:{
            placeholder:'换标业务或出库失败需重新入库时填写',
          },
          required: false,
          show:this.showTimeAft || this.formData.orderType == 2,
        },
        {
          label: this.$t('global.common.notes', { defaultValue: "备注" }),
          tag: "vTextarea",
          key: "remark",
          required: false
        },
        {
          label: this.$t('fbb.alloment.transfer_plan_no', { defaultValue: "关联调拨计划单号" }),
          key: "transferPlanRelNo",
          show: this.isManageBill && !this.showRel && this.checkWarehouse,
          render: h => {
            const {
              subRelTransferPlanStatus,
              transferPlanRelNo,
              transferPlanRelId,
              subRelOrgWarehouseCode
            } = this.formData;
            const data =
              this.getBillStatus.find(
                item => item.value === subRelTransferPlanStatus
              ) || {};
            return (
              <div>
                <a
                  onClick={this.handleOperates.bind(
                    this,
                    transferPlanRelId,
                    "query"
                  )}
                >
                  {transferPlanRelNo || "-"} ({subRelOrgWarehouseCode || "-"})
                </a>
                <vButton
                  ghost
                  theme={data.theme}
                  style="margin-left:5px;padding:1px 10px;cursor:unset;"
                >
                  {data.label}
                </vButton>
              </div>
            );
          }
        },{
          label: this.$t('fbb.alloment.transfer_plan_no', { defaultValue: "关联调拨计划单号" }),
          key: "transferPlanRelNo",
          show: this.isManageBill && !this.showRel && !this.checkWarehouse,
          render: h => {
            const {
              subRelTransferPlanStatus,
              transferPlanRelNo,
              transferPlanRelId,
              subRelOrgWarehouseCode
            } = this.formData;
            const data =
              this.getBillStatus.find(
                item => item.value === subRelTransferPlanStatus
              ) || {};
            return (
              <div>
                <span
                >
                  {transferPlanRelNo || "-"} ({subRelOrgWarehouseCode || "-"})
                </span>
                <vButton
                  ghost
                  theme={data.theme}
                  style="margin-left:5px;padding:1px 10px;cursor:unset;"
                >
                  {data.label}
                </vButton>
              </div>
            );
          }
        }
      ];
    }
  },
  methods: {
    cancel() {
      this.$router.push({
        name: this.isManageBill ? "allotManageBill" : "allotBill"
      });
      this.$emit("on-update");
    },
    handleOperates(params = "", type, batch) {
      if (batch === true) {
        params = (params || this.checkedData.join(",")) + "";
        if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: "请选择至少一条数据" }));
      }
      switch (type) {
        case "query":
          var url = this.$router.resolve({
            name: "allotUpdateManage",
            params: { type: "query" },
            query: { id: params }
          });
          window.open(url.href, "_blank");
          break;
      }
    },
    reprocess(){
          this.operate = {
                show: true,
                alert: "error",
                title: this.$t('fbb.alloment.reprocess', { defaultValue: "重处理" }),
                width: 400,
                showDesc: true,
                params: {
                    id:  this.id,
                    type:this.isManageBill ?  2 : 1
                },
                ajaxRequest: HttpReprocessPlanBill,
                callback: this.cancel
          };
    },
    backToNormal(){
          this.operate = {
                show: true,
                alert: "info",
                title: this.$t('fbb.alloment.back_to_normal', { defaultValue: "忽略异常" }),
                width: 400,
                showDesc: true,
                params: {
                    id: this.id,
                    type:this.isManageBill ?  2 : 1
                },
                ajaxRequest: HttpBackToNormalPlanBill,
                callback: this.cancel
          };
    },
    // 根据仓库获取对应的渠道列表
    getChannel(wareId, type) {
      HttpFindByOrgIdAndOrgWarehouseId({
        orgId: global.SYSID,
        orgWarehouseId: wareId
      }).then(
        res => {
          if (type === "outware") {
            this.channelList1 = [];
            this.channelList1 = res.data;
          } else {
            this.channelList2 = [];
            this.channelList2 = res.data;
          }
        },
        err => {
          this.$$VMessage.error(err.message);
        }
      );
    },
    //获取如仓库相关数据
    getInWarehouseAttach(attach, val) {
      // console.log(attach,val)
      this.formData.inOrgWarehouseCode = attach.code;
      if (!val) {
        this.clearWarehouseAddress();
        // this.$set(this.formData,'receiveStore',attach.code)
        this.formData.receiveStore = attach.code;
        this.codeList = [];
        return;
      }
      //当仓库是亚马逊仓时，需要传递仓库code
      if (attach.warehouseType == 2) {
        this.codeList = [];
        this.formData.receiveStore = "";
        this.getWHCodeList(val);
        return;
      }
      this.getWarehouseAddress({ warehouseId: val });
    },
    getAllotAddressByCode(attach, val) {
      // console.log(val)
      this.formData.receiveStore = val;
      if (!val) return;
      this.getWarehouseAddress({
        warehouseId: this.formData.inOrgWarehouseId,
        addressCode: val
      });
    },
    getDetail() {
        if (this.type === "add") return;
        this.loading = true;
        const ajaxRequest = this.isManageBill ? HttpSubPlanBill : HttpPlanBill;
        return ajaxRequest({ id: this.id }).then(res => {
            const data = res.data,
            body = data.transferOutboundPlanEntity;
            this.attachList = data.orderAttachesEntities || [];
            this.productList = body.transferOutboundPlanItemList || [];
            this.boxingList = body.transferOutboundPlanBoxItemList || [];
            this.subTransferPlansEntity = data.subTransferPlansEntity || [];
            this.logList = data.orderLogEntityList || [];
            delete body.transferOutboundPlanItemList;
            delete body.transferOutboundPlanBoxItemList;
            this.formData = data.transferOutboundPlanEntity || [];
            this.formData.outOrgWarehouseId = this.formData.orgWarehouseId;
            this.formData.outOrgWarehouseCode = this.formData.orgWarehouseCode;
            this.formData = { ...this.formData, ...this.subTransferPlansEntity};
            this.photoData.orderData = this.formData;
            this.photoData.orderType = 1;
            if(this.isManageBill){
                this.status = this.formData.subTransferPlanStatus;
            }else{
                this.status = this.formData.transferOutboundPlanStatus;
            }
            if(this.formData.subTransferPlanNo){
                this.checkManage = 0
            }else{
                this.checkManage = 1
            }
            if(this.subTransferPlansEntity.transferPlanRelId){
                //关联单据
                HttpSubPlanGet({
                    id: this.subTransferPlansEntity.transferPlanRelId
                }).then(res => {
                    if (res) {
                        this.formData.subRelTransferPlanStatus = res.data.subTransferPlanStatus;
                        this.formData.subRelOrgWarehouseCode = res.data.orgWarehouseCode;
                        this.formData = { ...this.formData, ...this.subTransferPlansEntity};
                    }
                });
            }
            if(this.formData.transferPlanRelId){
                this.showRel = false;
                HttpCheckWarehouse({
                    id: this.formData.transferPlanRelId,
                    contextId: global.SYSID,
                }).then(res => {
                    if(res.data === true){
                        this.checkWarehouse= true;
                        this.loading = false;
                    }else{
                        this.loading = false;
                    }
                });
            } else{
                this.showRel = true;
                this.loading = false;
            }
            this.formData.estimateOutboundTime = this.formData.estimateOutboundAt;
            this.formData.estimateInboundTime = this.formData.estimateInboundAt;
            delete this.formData.estimateOutboundAt;
            this.getWHCodeList(this.formData.inOrgWarehouseId);
            // 判断页面onsite渠道展示
            let allwarehouseList = this.isManageBill ? this.getBillcusWareList : this.getFBBFilterDisabledAllWarehouse;
            // console.log(this.getBillcusWareList)
            // console.log(allwarehouseList)
            if (this.type == "query") {
                if (data.transferOutboundPlanEntity.onsiteChannel) {
                    this.showOnaccount = true;
                }
                if (data.transferOutboundPlanEntity.inOnsiteChannel) {
                    this.showInaccount = true;
                }
            } else {
                let showOnaccount1 = allwarehouseList.filter(
                    item => { return (
                        item.attach.code ==
                        data.transferOutboundPlanEntity.orgWarehouseCode
                    );
                    })[0] || {};
                // console.log(showOnaccount1)
                if (showOnaccount1.attach.warehouseType == 4) {
                    this.getChannel( data.transferOutboundPlanEntity.orgWarehouseId, "outware");
                    this.showOnaccount = true;
                }
                let showInaccount2 = allwarehouseList.filter(item => {
                    return (
                        item.attach.code ==
                        data.transferOutboundPlanEntity.inOrgWarehouseCode
                    );
                })[0] || {};
                if (showInaccount2.attach.warehouseType == 4) {
                    this.getChannel( data.transferOutboundPlanEntity.inOrgWarehouseId, "inware" );
                    this.showInaccount = true;
                }
            }
        }).catch(err => {
            this.loading = false;
            this.$VMessage.error(err.message);
        });
    },
    getWarehouseAddress(data) {
      HttpWarehouseAddress(data)
        .then(res => {
          const {
            address,
            address2,
            city,
            state,
            country,
            postal,
            phone,
            mobilePhone,
            linkman,
            code
          } = res.data || {};
          this.formData = {
            ...this.formData,
            receiveStore: code,
            shipToAddress1: address,
            shipToAddress2: address2,
            shipToCity: city,
            shipToState: state,
            shipToCountry: country,
            shipToPostal: postal,
            shipToTelephone: phone,
            shipToMobile: mobilePhone,
            shipToContact: linkman
          };
        })
        .catch(err => {
          this.clearWarehouseAddress();
        });
    },
    clearWarehouseAddress() {
      this.formData = {
        ...this.formData,
        receiveStore: "",
        shipToAddress1: "",
        shipToAddress2: "",
        shipToCity: "",
        shipToState: "",
        shipToCountry: "",
        shipToPostal: "",
        shipToTelephone: "",
        shipToMobile: "",
        shipToContact: ""
      };
    },
    //仓库code list
    getWHCodeList(val) {
      if (this.type === "query" || !val) return;
      HttpWareHouseCodeList({
        warehouseId: val
      }).then(
        res => {
          this.codeList = res.data || [];
        },
        err => {
          this.$VMessage.error(err.message);
        }
      );
    },
    rebackaudit() {
      this.operate = {
        show: true,
        alert: "info",
        title: this.$t('fbb.alloment.cancel_audit', { defaultValue: "撤销审核" }),
        width: 460,
        params: { id: this.id },
        ajaxRequest: HttpRebackAuditPlanBill,
        callback: this.cancel
      };
    },
    cancelOrder() {
      this.operate = {
        show: true,
        alert: "error",
        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
        width: 460,
        showDesc: false,
        params: { id: this.id },
        ajaxRequest: HttpCancelPlanBill,
        formdata: [
          {
            tag: "vTextarea",
            key: "cancelReason",
            labelWidth: "auto",
            span: 24,
            label: this.$t('fbb.alloment.cancel_reason', { defaultValue: "取消原因" })
          }
        ],
         callback: this.cancel
      };
    },
    sure() {
      this.operate = {
        show: true,
        alert: "error",
        title: this.$t('global.datepicker.confirm', { defaultValue: "确认" }),
        width: 460,
        showDesc: false,
        params: { id: this.id },
        ajaxRequest: HttpAllSureBill,
        formdata: [
          {
            tag: "vTextarea",
            key: "remark",
            labelWidth: "auto",
            span: 24,
            label: this.$t('global.common.notes', { defaultValue: "备注" }),
            required: false,
          }
        ],
         callback: this.cancel
      };
    },
    repushWms(){
				this.loading = true;
			HttpRetryWms({ id: this.id }).then(res => {
				this.loading = false;
				this.$VMessage.success(res.message);
			}).catch(err => {
				this.$VMessage.error(err.message);
				this.loading = false;
			})
		},
    //完成
    submitComplete() {
      this.operate = {
        show: true,
        alert: "primary",
        showDesc: false,
        title: this.$t('global.common.finish', { defaultValue: "完成" }),
        params: { id: this.id },
        formdata: [
          {
            tag: "vTextarea",
            key: "completeReason",
            labelWidth: "auto",
            span: 24,
            label: this.$t('fbb.alloment.finish_reason', { defaultValue: "完成原因" })
          }
        ],
        ajaxRequest: HttpCompletePlanBill,
        callback: this.cancel
      };
      // this.loading = true;
      // HttpCompletePlanBill({ id: this.id }).then(res => {
      // 	this.cancel();
      // }, err => {
      // 	this.loading = false;
      // 	this.$VMessage.error(err.message);
      // });
    },
    //提交
    submitStatus(id, hasSku) {
      if (!hasSku) {
        this.loading = false;
        this.$VMessage.error(this.$t('fbb.alloment.error_tip', { defaultValue: "SKU明细不能为空" }));
        return;
      }
      HttpSubmiPlanBill({ id }).then(
        res => {
          this.cancel();
        },
        err => {
          this.loading = false;
          this.$VMessage.error(err.message);
        }
      );
    },
    //保存
    async submit(next) {
      if(this.type === "edit"||this.type === "add"){
 const valid = await this.$refs.formbase.validate();
      if (!valid) return;
      if(this.formData.inOrgWarehouseId == this.formData.orgWarehouseId){
        this.$VMessage.error(this.$t('fbb.alloment.error_tip_2', { defaultValue: "出库仓和入库仓不能相同!" }));
        return
      }
      }

      const ajaxRequest =
        this.type === "add" ? HttpSavePlanBill : HttpUpdatePlanBill;
      const productlist = this.$refs.productlist.dataList;

      // this.formData.onsiteChannel = this.channelList1.filter(item=>{return item.accountFlag == this.formData.onsiteWarehouseId})
      // this.formData.inOnsiteChannel = this.channelList2.filter(item=>{return item.accountFlag == this.formData.inOnsiteWarehouseId})

      this.loading = true;
      return ajaxRequest({
        ...this.formData,
        transferOutboundPlanItemModelList: productlist,
        transferOrderAttachModelList: this.$refs.attachlist.dataList
      }).then(
        res => {
          return next
            ? this.submitStatus(res.data.id || this.id, productlist.length)
            : this.cancel();
          this.cancel();
        },
        err => {
          this.loading = false;
          this.$VMessage.error(err.message);
        }
      );
    }
    //审核
    // approve() {

    // }
  }
};
</script>
